module.exports = __webpack_public_path__ + "static/media/botaodownload2.d91e1b12.png";